export default {
      id: "ic_info_white-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_info_white-usage",
      toString: function () {
        return this.url;
      }
    }